import{FlexLayout}from"@wp/src/components/common/grid";import styled from"@emotion/styled";import{TableCell}from"@heroui/react";export const CustomizeColumnContainer=styled(FlexLayout)`
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 8px 16px;
  border: ${props=>`1px solid ${props.theme.colors.neutral300}`};
  border-radius: 8px;
  cursor: pointer;
`;export const NextTableCell=styled(TableCell)`
  text-align: ${props=>props.align};
`;